import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import {
  TGroupChatGetHistoryRequest,
  TGroupChatGetHistoryResponse,
} from "../../api/group_chat/get_history";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";

export type TApiGroupChatGetHistoryResult = {
  result?: TGroupChatGetHistoryResponse;
};

export const fetchGroupChatGetHistory = async (
  params: TGroupChatGetHistoryRequest,
): Promise<TApiResult & TApiGroupChatGetHistoryResult> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;

  return await client()
    .group_chat.get_history.post({
      body: params,
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      if (res.body.status_code !== 0) {
        return {
          isSuccess: false,
          status: res.body.status_code,
          message: "",
        };
      }
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(
        e,
        "fetchGroupChatGetHistory",
      );
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
